var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"hy-swiper"}},[_c('div',{staticClass:"swiper",on:{"touchstart":_vm.touchStart,"touchmove":_vm.touchMove,"touchend":_vm.touchEnd}},[_vm._t("default")],2),_vm._t("indicator")],2)}
var staticRenderFns = []

export { render, staticRenderFns }